<template>
   <svg width="18" height="10" viewBox="0 0 18 10" xmlns="http://www.w3.org/2000/svg">
     <path d="M9.54 7.73H8.46L9 7.18l.54.55zM9 7.18L15.45.57a1.04 1.04 0 011.48-.02c.2.2.32.47.32.76 0 .27-.1.53-.3.74l-7.2 7.38c-.41.43-1.08.43-1.5 0l-7.2-7.38c-.4-.41-.4-1.07 0-1.48a1.04 1.04 0 011.5 0L9 7.18zm.32 1.2a.46.46 0 00-.64 0L9 8.06l.32.34z"/>
   </svg>
</template>

<script>
export default {
   name: 'ChevronDown'
}
</script>